export default __webpack_public_path__ + "static/media/weather.bb3181f0.png";